var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8125 4.8125C5.05412 4.8125 5.25 5.00838 5.25 5.25V10.5C5.25 10.7416 5.05412 10.9375 4.8125 10.9375C4.57088 10.9375 4.375 10.7416 4.375 10.5V5.25C4.375 5.00838 4.57088 4.8125 4.8125 4.8125Z",
    fill: "#D81F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.8125C7.24162 4.8125 7.4375 5.00838 7.4375 5.25V10.5C7.4375 10.7416 7.24162 10.9375 7 10.9375C6.75838 10.9375 6.5625 10.7416 6.5625 10.5V5.25C6.5625 5.00838 6.75838 4.8125 7 4.8125Z",
    fill: "#D81F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 5.25C9.625 5.00838 9.42912 4.8125 9.1875 4.8125C8.94588 4.8125 8.75 5.00838 8.75 5.25V10.5C8.75 10.7416 8.94588 10.9375 9.1875 10.9375C9.42912 10.9375 9.625 10.7416 9.625 10.5V5.25Z",
    fill: "#D81F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 2.625C12.6875 3.10825 12.2957 3.5 11.8125 3.5H11.375V11.375C11.375 12.3415 10.5915 13.125 9.625 13.125H4.375C3.4085 13.125 2.625 12.3415 2.625 11.375V3.5H2.1875C1.70425 3.5 1.3125 3.10825 1.3125 2.625V1.75C1.3125 1.26675 1.70425 0.875 2.1875 0.875H5.25C5.25 0.391751 5.64175 0 6.125 0H7.875C8.35825 0 8.75 0.391751 8.75 0.875H11.8125C12.2957 0.875 12.6875 1.26675 12.6875 1.75V2.625ZM3.60328 3.5L3.5 3.55164V11.375C3.5 11.8582 3.89175 12.25 4.375 12.25H9.625C10.1082 12.25 10.5 11.8582 10.5 11.375V3.55164L10.3967 3.5H3.60328ZM2.1875 2.625H11.8125V1.75H2.1875V2.625Z",
    fill: "#D81F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.76b6657f6929cdafd0bbcce812713a00.svg";
export { ForwardRef as ReactComponent };